import React, { useState } from 'react';
import IntegrationStatusBadge from './IntegrationStatusBadge';
import { formatDateTime } from '../lib/openPlatformFormatters';

const integrationTypes = ['PAYMENT_GATEWAY', 'ROUTER_VENDOR', 'OLT_VENDOR', 'WHATSAPP_PROVIDER', 'CRM', 'ERP', 'OSS_PARTNER', 'CUSTOM'];

const IntegrationRegistryPanel = ({ items = [], onCreate, onActivate, onDisable, loading }) => {
  const [providerName, setProviderName] = useState('');
  const [integrationType, setIntegrationType] = useState('PAYMENT_GATEWAY');

  const handleCreate = (event) => {
    event.preventDefault();
    if (!providerName.trim() || loading) return;
    onCreate({ providerName: providerName.trim(), integrationType, config: {} });
    setProviderName('');
  };

  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/70">
      <div className="border-b border-slate-800 px-3 py-2">
        <h3 className="text-sm font-semibold text-slate-100">Integration Registry</h3>
      </div>
      <form onSubmit={handleCreate} className="grid gap-2 border-b border-slate-800 p-3 md:grid-cols-[1fr_220px_160px]">
        <input
          value={providerName}
          onChange={(e) => setProviderName(e.target.value)}
          placeholder="Nama provider"
          className="rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100"
        />
        <select
          value={integrationType}
          onChange={(e) => setIntegrationType(e.target.value)}
          className="rounded border border-slate-700 bg-slate-950 px-2 py-2 text-xs text-slate-100"
        >
          {integrationTypes.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
        <button type="submit" className="rounded border border-cyan-400/40 bg-cyan-500/10 px-2 py-2 text-xs font-semibold text-cyan-200">
          Tambah Integrasi
        </button>
      </form>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead className="bg-slate-950/80 text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Provider</th>
              <th className="px-3 py-2 text-left">Tipe</th>
              <th className="px-3 py-2 text-left">Status</th>
              <th className="px-3 py-2 text-left">Updated</th>
              <th className="px-3 py-2 text-left">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.integrationId} className="border-t border-slate-800 text-slate-200">
                <td className="px-3 py-2">
                  <p className="font-semibold text-slate-100">{item.providerName}</p>
                  <p className="text-[11px] text-slate-500">{item.integrationId}</p>
                </td>
                <td className="px-3 py-2">{item.integrationType}</td>
                <td className="px-3 py-2"><IntegrationStatusBadge status={item.status} /></td>
                <td className="px-3 py-2">{formatDateTime(item.updatedAt)}</td>
                <td className="px-3 py-2">
                  <div className="flex gap-2">
                    <button type="button" onClick={() => onActivate(item.integrationId)} className="rounded border border-emerald-400/40 bg-emerald-500/10 px-2 py-1 text-[11px] text-emerald-200">Activate</button>
                    <button type="button" onClick={() => onDisable(item.integrationId)} className="rounded border border-red-400/40 bg-red-500/10 px-2 py-1 text-[11px] text-red-200">Disable</button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-3 py-6 text-center text-slate-500">Belum ada integrasi terdaftar.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IntegrationRegistryPanel;
